import { createContext, useContext } from 'react';
const SelectContext = createContext({});
export const useSelect = () => useContext(SelectContext);
export const SelectProvider = SelectContext.Provider;
//# sourceMappingURL=useSelect.js.map